import './index.scss'
import '../../assets/scripts/number.js'
import Swiper from 'swiper/swiper-bundle.min.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section1").offset().top - $("header").height() * 3  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section1").offset().top - $("header").height() * 3  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

var swiper = new Swiper(".section2 .swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 2.875,
            slidesPerGroup: 2.875,
            spaceBetween: '1.82%',
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
        }
    }, 
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
});

var swiper = new Swiper(".section3 .swiper", {
    loop:true,
    observer: true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents: true,//修改swiper的父元素时，自动初始化swiper
    speed:4000,//匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 6,
        spaceBetween: '3.28125%',
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }, 
});